import { getApiBaseUrl, requestJson } from "@/lib/api";

export type OrderReportCategory = "TODOS" | "ENTREGUES" | "CANCELADOS" | "ALTERADOS";

export interface OrderReportRequest {
  from: string;
  to: string;
  customerId?: string | null;
  category?: OrderReportCategory;
}

export interface OrderReportLine {
  date: string | null;
  orderId: string;
  orderNumber: number | null;
  customerId: string | null;
  clientName: string | null;
  productName: string;
  unit: string;
  quantity: number;
  value: number;
  status: string;
  delivered: boolean;
  cancelled: boolean;
  altered: boolean;
}

export interface OrderReport {
  from: string;
  to: string;
  orderCount: number;
  lines: OrderReportLine[];
  totals: {
    lineCount: number;
    totalQuantity: number;
    totalValue: number;
  };
}

export async function fetchOrderReport(req: OrderReportRequest): Promise<OrderReport> {
  return requestJson<OrderReport>("/api/v1/reports/orders", {
    method: "POST",
    body: req,
  });
}

export async function downloadOrderReportExport(
  req: OrderReportRequest,
  format: "pdf" | "csv",
): Promise<{ filename: string; blob: Blob }> {
  const response = await fetch(`${getApiBaseUrl()}/api/v1/reports/orders/export.${format}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  });
  if (!response.ok) {
    throw new Error("Não foi possível gerar o arquivo");
  }
  const disposition = response.headers.get("content-disposition") ?? "";
  const match = /filename="?([^";]+)"?/i.exec(disposition);
  const filename = match?.[1] ?? `pedidos.${format}`;
  const blob = await response.blob();
  return { filename, blob };
}
